import React, { useState } from "react";
import banner from '../assets/images/reviewBanner.jpg'
import { Link } from "react-router-dom";

const Review = () => {
    const [allowPost, setAllowPost] = useState(false);
  return (
    <>
    <div className='review-banner position-relative bottom-overlay'>
        <img src={banner} className='cover'/>
    </div>
    <div className='review-content-block bg-black color-light pt-20 pb-150'>
        <div className='container'>
            <div className='grid-blocks d-grid column-2 gap-50 d-gap-20'>
                <div className='grid-block'>
                    <div className='summary-block text-center d-text-left'>
                        <h1 className='mb-20'>Leave us a review</h1>
                        <div className='text-block font-18'>Our team would greatly appreciate if you left us a review at your convenience. We appreciate your support as always.</div>
                    </div>
                </div>
                <div className='grid-block'>
                    <div className='button-block text-center d-text-right'>
                        <label className="post-review d-flex align-center gap-10 font-16 justify-center d-justify-end mb-30">
                            <span className={`check-wrapper ${allowPost ? "checked" : ""}`}><input
                            type="checkbox"
                            checked={allowPost}
                            onChange={() => setAllowPost(!allowPost)}
                            className=""
                            /></span>
                            Allow this review to be posted on our website.
                        </label>

                        <Link to=''
                        onClick={() => window.open("https://g.page/r/CcUvDqGNkolVEAE/review")}
 
                        className="button uppercase py-15 px-25 border-light-1">LEAVE A GOOGLE REVIEW</Link>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    </>
  )
}

export default Review